const disKey = /Mac|iPod|iPhone|iPad/.test(navigator.platform)
  ? "metaKey"
  : "ctrlKey";

export function discontiguousKey(evt) {
  if (!evt) return false;
  return evt[disKey];
}

export function modifierKey(evt) {
  if (!evt) return false;
  return evt.metaKey || evt.ctrlKey || evt.shiftKey;
}
